import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, Download, Shield, Mail } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
const includes = ['Guía completa en PDF (7 días)', 'Menú, recetas y lista de compras', 'Rutinas y hábitos diarios', 'Acceso inmediato por email', 'Descarga ilimitada en cualquier dispositivo'];
export function PricingSection() {
  return <section className="bg-wellness-white py-20 px-6" id="pricing" data-id="element-132">
      <div className="max-w-2xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-wellness-light-sage text-center relative overflow-hidden" data-id="element-134">
          {/* Decorative elements */}
          <div className="absolute -right-16 -top-16 w-48 h-48 bg-wellness-sage/10 rounded-full blur-3xl" data-id="element-135" />
          <div className="absolute -left-16 -bottom-16 w-48 h-48 bg-wellness-gold/10 rounded-full blur-3xl" data-id="element-136" />

          <div className="relative z-10" data-id="element-137">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-wellness-dark mb-2" data-id="element-138">
              Tu guía por solo
            </h2>

            <div className="text-5xl md:text-6xl font-bold text-wellness-gold mb-2" data-id="element-139">
              US$ 6.36
            </div>

            <p className="text-wellness-dark/60 mb-8" data-id="element-140">
              Un solo pago. Sin suscripciones. Sin costos ocultos.
            </p>

            <div className="bg-wellness-light-sage/30 rounded-2xl p-6 mb-8 text-left max-w-sm mx-auto" data-id="element-141">
              <ul className="space-y-3" data-id="element-142">
                {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-143">
                    <CheckCircle2 className="w-5 h-5 text-wellness-green flex-shrink-0 mt-0.5" data-id="element-144" />
                    <span className="text-wellness-dark" data-id="element-145">{item}</span>
                  </li>)}
              </ul>
            </div>

            <a href="https://cuerpoencalma.it.com/cart/49295445262573:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('pricing_cta')} className="inline-block w-full bg-wellness-gold text-white px-8 py-4 rounded-full font-bold text-lg tracking-wide shadow-xl shadow-wellness-gold/30 hover:bg-yellow-600 transition-all hover:scale-105 active:scale-95 mb-6" data-id="element-146">
              Quiero mi guía — US$ 6.36
            </a>

            {/* Delivery clarity box */}
            <div className="bg-wellness-light-sage/50 rounded-2xl p-4 mb-6 text-left" data-id="element-147">
              <div className="flex items-start gap-3" data-id="element-148">
                <Mail className="w-5 h-5 text-wellness-green flex-shrink-0 mt-0.5" data-id="element-149" />
                <div data-id="element-150">
                  <p className="font-bold text-wellness-dark text-sm mb-1" data-id="element-151">
                    ¿Qué pasa después de pagar?
                  </p>
                  <p className="text-sm text-wellness-dark/70" data-id="element-152">
                    Recibes un email con el enlace de descarga en menos de 5
                    minutos. Si no lo ves, revisa tu carpeta de spam.
                  </p>
                </div>
              </div>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap justify-center items-center gap-4 text-sm text-wellness-dark/60" data-id="element-153">
              <span className="flex items-center gap-1" data-id="element-154">
                <Lock className="w-4 h-4" data-id="element-155" /> Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-156">
                <Download className="w-4 h-4" data-id="element-157" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-158">
                <Shield className="w-4 h-4" data-id="element-159" /> Garantía 7 días
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}